export const FLEX_PUFF_ENGINE_JOULE_ENABLED = 'ENABLE';
export const FLEX_PUFF_ENGINE_JOULE_DISABLE = 'DISABLE';
